// Ensure global toggle function exists for dynamically injected upsell snippet
if (!window.toggleUpsellContent) {
  window.toggleUpsellContent = function(header) {
    try {
      const upsell = header.closest('.cart-upsell');
      if (!upsell) return;
      const content = upsell.querySelector('.cart-upsell__content');
      const toggle = upsell.querySelector('.cart-upsell__toggle');
      if (!content) return;
      const isHidden = content.style.display === 'none' || content.style.display === '';
      if (isHidden) {
        content.style.display = 'block';
        toggle && toggle.classList.add('rotated');
        upsell.classList.add('expanded');
      } else {
        content.style.display = 'none';
        toggle && toggle.classList.remove('rotated');
        upsell.classList.remove('expanded');
      }
    } catch (e) {
      console.error('toggleUpsellContent error', e);
    }
  }
}

class CartCheckboxUpsell {
  constructor(cartItemsInstance) {
    this.cartItemsInstance = cartItemsInstance;
    this.baseUrl = "/cart";
    this.checkboxUpsellVariantId = this.getUpsellCheckboxVariantId();
    this.isUpdating = false; // Flag to prevent multiple simultaneous updates
    this.hasInitialized = false; // Track if this is the initial load
    this.isRemovingOrphans = false; // Flag to prevent cleanup loops
    this.lastCartItemCount = null; // Track last cart size to detect transitions from empty -> first item
    this.initEventDelegation();
    document.addEventListener("cartUpdated", this.handleCartUpdate.bind(this));
    this.updateCheckboxState();
  }

  initEventDelegation() {
    // Remove any existing listeners to prevent duplicates
    document.body.removeEventListener("change", this.handleCheckboxChange);
    
    // Bind the method to preserve 'this' context
    this.handleCheckboxChange = (event) => {
      if (event.target.id === "cart-upsell-checkbox" && !this.isUpdating) {
        this.isUpdating = true; // Prevent multiple simultaneous updates
        this.showLoadingSpinner();
        const isChecked = event.target.checked;
        if (isChecked) {
          this.addUpsellCheckboxToCart();
        } else {
          this.removeUpsellCheckboxFromCart();
        }
        // Reset flag after a delay
        setTimeout(() => {
          this.isUpdating = false;
        }, 1000);
      }
    };
    
    document.body.addEventListener("change", this.handleCheckboxChange);
  }

  showLoadingSpinner() {
    const loadingSpinner = document.querySelector('.cart-upsell__loading');
    if (loadingSpinner) {
      loadingSpinner.classList.remove('hidden');
    }
  }

  hideLoadingSpinner() {
    const loadingSpinner = document.querySelector('.cart-upsell__loading');
    if (loadingSpinner) {
      loadingSpinner.classList.add('hidden');
    }
  }

  getUpsellCheckboxVariantId() {
    return document
      .querySelector("#cart-upsell-checkbox")
      ?.getAttribute("data-variant-id");
  }

  updateCheckboxState() {
    // Refresh variant id in case the checkbox was inserted after initial load
    this.checkboxUpsellVariantId = this.getUpsellCheckboxVariantId();

    fetch(`${this.baseUrl}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const currentItemCount = cart.items?.length || 0;
        const hadItemsPreviously = this.lastCartItemCount !== null && this.lastCartItemCount > 0;
        const wasPreviouslyEmpty = this.lastCartItemCount === 0 || this.lastCartItemCount === null;

        const hasUpsellCheckbox = cart.items.some(
          (item) => item.variant_id.toString() === this.checkboxUpsellVariantId
        );
        const checkboxUpsellCheckbox = document.querySelector(
          "#cart-upsell-checkbox"
        );

        // If cart just became empty, reset checkbox UI to default (checked)
        if (currentItemCount === 0) {
          if (checkboxUpsellCheckbox) {
            // Temporarily detach listener to avoid triggering change handler
            document.body.removeEventListener("change", this.handleCheckboxChange);
            checkboxUpsellCheckbox.checked = true; // default state when cart is empty
            // Reattach
            setTimeout(() => {
              document.body.addEventListener("change", this.handleCheckboxChange);
            }, 50);
          }
        }

        // Detect transition from empty cart -> first item added (excluding upsell auto-add)
        if (wasPreviouslyEmpty && currentItemCount > 0) {
          // Force checkbox to be checked and add upsell if not present
          if (checkboxUpsellCheckbox) {
            document.body.removeEventListener("change", this.handleCheckboxChange);
            if (!checkboxUpsellCheckbox.checked) {
              checkboxUpsellCheckbox.checked = true;
            }
            setTimeout(() => {
              document.body.addEventListener("change", this.handleCheckboxChange);
            }, 50);
          }

          if (
            !hasUpsellCheckbox &&
            checkboxUpsellCheckbox &&
            checkboxUpsellCheckbox.checked
          ) {
            this.addUpsellCheckboxToCart();
          }
        }

        if (checkboxUpsellCheckbox) {

          if (
            !this.hasInitialized &&
            checkboxUpsellCheckbox.checked &&
            !hasUpsellCheckbox &&
            currentItemCount > 0
          ) {
            this.hasInitialized = true;
            this.addUpsellCheckboxToCart();
            this.lastCartItemCount = currentItemCount; // update before returning
            return;
          }
          
          // For subsequent updates, sync checkbox with cart state
          if (this.hasInitialized && checkboxUpsellCheckbox.checked !== hasUpsellCheckbox) {
            // Temporarily remove event listener to prevent triggering change event
            document.body.removeEventListener("change", this.handleCheckboxChange);
            checkboxUpsellCheckbox.checked = hasUpsellCheckbox;
            // Re-add event listener after a short delay
            setTimeout(() => {
              document.body.addEventListener("change", this.handleCheckboxChange);
            }, 50);
          }
          
          this.hasInitialized = true;
        }

        this.lastCartItemCount = currentItemCount; // update tracker
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }

  handleCartUpdate() {
    // Skip if we're currently removing orphans to prevent loops
    if (this.isRemovingOrphans) {
      return;
    }
    
    // Add debounce to prevent multiple rapid updates
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }
    this.updateTimeout = setTimeout(() => {
      if (!this.isUpdating) {
        this.checkAndRemoveOrphanedUpsell().then(() => {
          this.updateCheckboxState();
        });
      }
    }, 500); // Increased timeout to ensure cart state has settled
  }

  async checkAndRemoveOrphanedUpsell() {
    if (this.isRemovingOrphans) return; // Prevent multiple simultaneous cleanups
    
    try {
      const response = await fetch(`${this.baseUrl}.js`);
      const cart = await response.json();
      
      console.log('Checking cart for orphaned items:', cart.items?.length || 0, 'items');
      
      if (!cart.items || cart.items.length === 0) return;
      
      // Check if cart only contains fast processing items
      const onlyFastProcessing = cart.items.every(item => {
        const isFastProcessing = item.properties && 
          (item.properties._fast_processing === 'true' || 
           item.properties._fast_processing === true ||
           String(item.properties._fast_processing).toLowerCase() === 'true');
        console.log('Item:', item.product_title, 'Fast processing:', isFastProcessing);
        return isFastProcessing;
      });
      
      if (onlyFastProcessing) {
        console.log('Only fast processing items remain, removing them...');
        this.isRemovingOrphans = true;
        
        const updates = {};
        cart.items.forEach(item => {
          updates[item.key] = 0;
        });
        
        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        
        if (updateResponse.ok) {
          console.log('Successfully removed orphaned fast processing items');
          // Trigger cart UI refresh
          if (this.cartItemsInstance && typeof this.cartItemsInstance.onCartUpdate === "function") {
            this.cartItemsInstance.onCartUpdate();
          }
        }
        
        // Reset flag after a delay to allow cart updates to complete
        setTimeout(() => {
          this.isRemovingOrphans = false;
        }, 1000);
      }
    } catch (error) {
      console.error('Error checking for orphaned upsell items:', error);
      this.isRemovingOrphans = false;
    }
  }

  addUpsellCheckboxToCart() {
    // Ensure we have the latest variant id
    this.checkboxUpsellVariantId = this.getUpsellCheckboxVariantId();
    if (!this.checkboxUpsellVariantId) {
      console.warn("Cart upsell variant id not found. Skipping add.");
      return;
    }
    const formData = new FormData();
    formData.append("id", this.checkboxUpsellVariantId);
    formData.append("quantity", 1);

    if (window.theme?.settings?.cart_upsell_fast_processing) {
      formData.append("properties[_fast_processing]", "true");
    }

    fetch(`${this.baseUrl}/add.js`, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        this.hideLoadingSpinner();
        if (response.ok) {
          // Trigger cart update for cart items
          if (
            this.cartItemsInstance &&
            typeof this.cartItemsInstance.onCartUpdate === "function"
          ) {
            this.cartItemsInstance.onCartUpdate();
          }
          // Also update the cart footer sections
          this.onCartUpdateCheckboxUpsell();
        }
        return response.json();
      })
      .catch((error) => {
        this.hideLoadingSpinner();
        console.error("Error adding cart upsell:", error);
      });
  }

  removeUpsellCheckboxFromCart() {
    // Ensure we have the latest variant id
    this.checkboxUpsellVariantId = this.getUpsellCheckboxVariantId();
    if (!this.checkboxUpsellVariantId) {
      console.warn("Cart upsell variant id not found. Skipping remove.");
      return;
    }
    // Use the direct cart update API instead of updateQuantity to avoid line number issues
    const updates = {};
    
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Find the upsell item and set its quantity to 0
        cart.items.forEach((item, index) => {
          if (item.variant_id.toString() === this.checkboxUpsellVariantId) {
            updates[item.key] = 0;
          }
        });
        
        if (Object.keys(updates).length > 0) {
          // Use cart update API with item keys instead of line numbers
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates })
          });
        } else {
          console.error("Cart upsell product not found in cart.");
          return Promise.reject("Product not found");
        }
      })
      .then((response) => {
        this.hideLoadingSpinner();
        if (response && response.ok) {
          // Trigger cart update for cart items
          if (this.cartItemsInstance && typeof this.cartItemsInstance.onCartUpdate === "function") {
            this.cartItemsInstance.onCartUpdate();
          }
          // Also update the cart footer sections
          this.onCartUpdateCheckboxUpsell();
        }
        return response ? response.json() : null;
      })
      .catch((error) => {
        this.hideLoadingSpinner();
        console.error("Error removing cart upsell:", error);
      });
  }

  getSectionsToRenderCheckboxUpsell() {
    const mainCartFooter = document.getElementById("main-cart-footer");
    const sections = [
      ...(mainCartFooter
        ? [
            {
              id: "main-cart-footer",
              section: mainCartFooter.dataset.id,
              selector: "#main-cart-footer .js-contents",
            },
          ]
        : []),
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: "#cart-icon-bubble",
      },
    ];
    return sections;
  }

  onCartUpdateCheckboxUpsell() {
    this.getSectionsToRenderCheckboxUpsell().forEach((section) => {
      fetch(`${this.baseUrl}?section_id=${section.section}`)
        .then((response) => response.text())
        .then((html) => {
          const container = document.querySelector(section.selector);
          if (!container) {
            console.error(
              `Container not found for selector: ${section.selector}`
            );
            return;
          }
          if (section.id === "main-cart-footer") {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const jsContents = doc.querySelector(".js-contents");

            if (jsContents) {
              container.innerHTML = jsContents.innerHTML;
            } else {
              console.error(
                `.js-contents not found in fetched HTML for section: ${section.id}`
              );
            }
          } else if (section.id === "cart-icon-bubble") {
            container.innerHTML = html;
          }
        })
        .catch((error) =>
          console.error(`Error updating section ${section.id}:`, error)
        );
    });
  }
}

// Make CartCheckboxUpsell available globally
window.CartCheckboxUpsell = CartCheckboxUpsell;

document.addEventListener("DOMContentLoaded", function () {
  initializeCartCheckboxUpsell();
});

function initializeCartCheckboxUpsell() {
  const cartItemsInstance = document.querySelector("cart-items");
  const cartDrawerItemsInstance = document.querySelector("cart-drawer-items");
  let activeCartInstance = cartDrawerItemsInstance || cartItemsInstance;
  
  if (activeCartInstance && !window.cartCheckboxUpsellInstance) {
    window.cartCheckboxUpsellInstance = new CartCheckboxUpsell(activeCartInstance);
  } else if (!activeCartInstance) {
    console.log("Neither cart-items nor cart-drawer-items found in the DOM.");
  }
}
